// extracted by mini-css-extract-plugin
module.exports = {"scroll-black":"search_scroll-black__b1KyL","title":"search_title___3YY_","wrapper":"search_wrapper__oFLj8"};